import React, { useEffect, useState } from "react";
import axios from "axios";
const AboutUs = () => {
  const [aboutUs, setAboutUs] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(process.env.REACT_APP_BACKEND + "aboutus")
      .then((resp) => {
        setAboutUs(resp.data.data.html);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching About Us:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="container py-5" style={{ width: "auto" }}>
      <h1 className="t-center">About Us</h1>
      <p className="t-center mt-1" style={{ color: "var(--grey-color)" }}>
        Our Story
      </p>
      <div className="row mt-5">
        <div className="col-12">
          {loading ? (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div
              className="p-3 aboutdiv"
              style={{
                borderRadius: "6px",
                position: "relative",
              }}
              dangerouslySetInnerHTML={{
                __html: `
      <style>
        * {
          box-sizing: border-box;
        }
        .aboutdiv {
          text-align: left !important;
          padding: 5% !important;
        }
        .aboutdiv h1, .aboutdiv h2 {
          font-size: clamp(1.2rem, 2.5vw, 1.8rem); /* Reduced size range */
          margin-bottom: 1rem;
          line-height: 1.2;
          font-weight: 600; /* Slightly bold for emphasis */
        }
        .aboutdiv p {
          font-size: clamp(0.9rem, 2vw, 1.1rem); /* Slightly smaller base */
          margin-bottom: 1rem;
          line-height: 1.5;
        }
        .aboutdiv ul {
          padding-left: 0 !important;
          margin-left: 0 !important;
          list-style-position: inside !important;
        }
        .aboutdiv li {
          font-size: clamp(0.9rem, 2vw, 1.1rem); /* Match paragraph size */
          margin-left: 0 !important;
          padding-left: 0 !important;
          margin-bottom: 0.75rem !important;
        }
        /* Media queries for smaller screens */
        @media (max-width: 768px) {
          .aboutdiv h1, .aboutdiv h2 {
            font-size: clamp(1rem, 2vw, 1.5rem); /* Further reduce on tablets */
          }
          .aboutdiv p, .aboutdiv li {
            font-size: clamp(0.8rem, 1.8vw, 1rem);
          }
          .aboutdiv {
            padding: 3% !important;
          }
        }
        @media (max-width: 480px) {
          .aboutdiv h1, .aboutdiv h2 {
            font-size: 1rem; /* Fixed size for very small screens */
          }
          .aboutdiv p, .aboutdiv li {
            font-size: 0.8rem;
          }
          .aboutdiv {
            padding: 2% !important;
          }
        }
      </style>
      ${aboutUs}
    `,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
